module.exports = __webpack_public_path__ + "img/callcenter01.9b2c443a.svg";